export default {
    AddInternalRefundOnlyDoc: {
        Associate: 'Associated sales order',
        Select: 'Select associated sales order',
        Basic: 'Account Information',
        Refund: 'Refund order type',
        type: 'Refund type',
        Tripartite: 'Third-party refund Order No.',
        Three: 'Third-party refund time',
        reason: 'Refund reason',
        stage: 'Refund stage',
        Customer: 'CSG Comments',
        Financial: 'Financial information',
        Settlement: 'Settlement method',
        Product: 'Product Information',
        Add: 'Add refund item',
        Image: 'Image attachment',
        an: 'Select associated sales order',
        the: 'Select refunded item(s)',
        sales: 'Associated sales order',
        Other: 'Other',
        Unshipped: 'Unshipped quantity',
        Quantity: 'Refunded quantity',
        Refundable: 'Refundable quantity',
        Shipment: 'Shipment status',
        Preemption: 'Reservation Status',
        Sourcing: 'Sourcing Status',
        selectform: 'Please select refund order type',
        selecttype: 'Please select refund type',
        enternumber: 'Please enter third-party refund Order No.',
        selectrefund: 'Please select third-party refund time',
        selectreason: 'Please select refund reason',
        selectstage: 'Please select refund stage',
        selectmethod: 'Please select settlement method',
        Delete: 'Delete',
        form: {
            Giveaway: 'Whether it is a gift',
            Product: 'Number of Item Lines',
            Refundable: 'Quantity available for refund',
            Refund: 'Quantity to be refunded',
            unit: 'Refund unit price',
            Total: 'Total refund amount',
        },
        info: {
            Please: 'Please select a related sales order first',
            add: 'Please add refundable products first',
            Deletion: 'Deletion successful',
            an: 'Please select a related sales order first',
            The: 'The refundable quantity is 0',
            returned: 'The returned data is empty, please contact the administrator',
        }
    }
};
